import React from 'react';
import { Grid, Dropdown } from 'semantic-ui-react';

export const InputsDropdowns = () => (
  <Grid>
    <Grid.Row>
      <Grid.Column>
        <h4>Dropdowns</h4>
      </Grid.Column>
    </Grid.Row>
    <Grid.Row columns={3} className="style-guide--group">
      <Grid.Column>
        <Dropdown
          placeholder="Suggest Text"
          options={[{ value: 1, text: 'One' }]}
        />
      </Grid.Column>
    </Grid.Row>
    <Grid.Row>
      <Grid.Column>
        <h4>Full Width Dropdowns</h4>
      </Grid.Column>
    </Grid.Row>
    <Grid.Row columns={3} className="style-guide--group">
      <Grid.Column>
        <Dropdown
          className="input--full"
          placeholder="Suggest Text"
          options={[{ value: 1, text: 'One' }]}
        />
      </Grid.Column>
    </Grid.Row>
  </Grid>
);



// WEBPACK FOOTER //
// ./src/pages/styleguide/components/Forms/inputs-dropdowns.js